import React from "react";
import { Typography } from "./typography";
import { Skeleton } from "./skeleton";

interface BalanceDisplayProps {
  amount: string;
  label?: string;
  variant?: "default" | "compact";
  isLoading?: boolean;
}

const BalanceDisplay: React.FC<BalanceDisplayProps> = ({
  label = "Balance Available:",
  amount,
  variant = "default",
  isLoading = false,
}) => {
  if (variant === "compact") {
    return (
      <div className="py-2.5 px-3 border border-gray-100 bg-gray-50 rounded-lg">
        <Typography variant="p" className="text-sm">
          <span className="font-medium text-gray-500">{label}</span>{" "}
          {isLoading ? (
            <Skeleton className="h-4 w-4 rounded-full bg-gray-300" />
          ) : (
            <span className="font-medium text-gray-900">{amount}</span>
          )}
        </Typography>
      </div>
    );
  }

  return (
    <div className="py-2.5 px-4 border border-gray-100 bg-gray-50 rounded-lg">
      <Typography variant="p">{label}</Typography>
      {isLoading ? (
        <Skeleton className="h-4 w-4 rounded-full bg-gray-300" />
      ) : (
        <Typography variant="span">{amount}</Typography>
      )}
    </div>
  );
};

export default BalanceDisplay;
